import { useConfigContext } from "@/state/configContext";
import { server } from "@/state/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import type { ReactNode } from "react";

export function Fotografos({
  fotografos,
  todos,
  LinkTo,
}: {
  fotografos: [number, number][];
  todos?: boolean;
  LinkTo: (p: { id: number; children: ReactNode }) => ReactNode;
}) {
  const config = useConfigContext();

  return (
    <div className="fotografos">
      {[
        ...fotografos.map(([numero, id]) => ({
          id,
          nombre: `${numero}.- ${config.fotografos[id].nombre}`,
          foto: <img src={`${server}/fotografo/${id}.jpg`} />,
        })),
        ...(todos
          ? [
              {
                id: 0,
                nombre: "Todos",
                foto: (
                  <FontAwesomeIcon icon={faUsers} className="fotografo-todos" />
                ),
              },
            ]
          : []),
      ].map((f) => (
        <LinkTo key={f.id} id={f.id}>
          <div className="fotografo">
            {f.foto}
            <div>{f.nombre}</div>
          </div>
        </LinkTo>
      ))}
    </div>
  );
}
